/**
 * Configure PDF.js worker for react-pdf
 * 
 * CRITICAL FIX: Copy worker file to public directory to avoid CDN loading failures
 * This ensures the worker loads correctly without external dependencies
 */

// OPTION 1: Use local copy from node_modules (copy worker to public/pdf-worker during build)
// You'll need to add this to your build process:
// 1. Copy node_modules/pdfjs-dist/build/pdf.worker.min.mjs to public/pdf-worker.min.mjs
// 2. Configure worker to use local file

import { pdfjs } from 'react-pdf';

// Use local worker file instead of CDN
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
)?.toString();

// Log configuration for debugging
console.log('✅ PDF.js worker configured');
console.log('📦 Worker version:', pdfjs?.version);
console.log('📦 Worker source:', pdfjs?.GlobalWorkerOptions?.workerSrc);

/**
 * Alternative configuration function for manual setup if needed
 * Not auto-executed to prevent conflicts
 */
export const configurePdfWorker = () => {
  try {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.min.mjs',
      import.meta.url,
    )?.toString();
    console.log('✅ PDF.js worker manually configured');
  } catch (error) {
    console.error('❌ Failed to configure PDF.js worker:', error);
  }
};

export default pdfjs;